import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AddtionalParams } from '../../models/dictation.interface';

@Component({
    standalone: false,
    selector: 'cva-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrl: './custom-select.component.scss',
    
})
export class CustomSelectComponent {
  @Input() options?: string[] = [];
  @Input() selectedValue: string = "";
  @Input() isActivated: boolean = false;
  @Input() additionalParams: AddtionalParams = { sectionIndex: -1, subSectionIndex: -1, index: -1, column: -1 }
  @Output() getUpdatedValue = new EventEmitter<{ codes: string, additionalParams: AddtionalParams }>();
  @Output() directClicked = new EventEmitter<AddtionalParams>();

  @HostListener('window:click', ['$event'])
  onClick() {
    this.isActivated = false;
  }

  showOptions(event: MouseEvent) {
    this.directClicked.emit(this.additionalParams);
    this.activated(event, true);
  }

  activated(event: MouseEvent, flag: boolean) {
    this.isActivated = flag;
    event.stopPropagation();
  }

  selected(event: MouseEvent, codes: string) {
    this.getUpdatedValue.emit({
      codes: codes,
      additionalParams: this.additionalParams
    });
    this.activated(event, false)
  }

}
